import * as React from 'react';
import { emptyArray } from 'vet-bones/constants';
import { noop } from 'vet-bones/utils';

import { useDataModels } from 'src/containers/ProjectModelDialog/hooks/useDataModels';
import { ModelSelectItem } from 'src/selectors/modelItems';
import { PendingModelData } from 'src/store/state/projects';

type ImportModelContextValue = {
  databaseId: string;
  dataModels: string[];
  unimportableNamedGraphIris: string[];
  selectedModels: ModelSelectItem[];
  pendingModelData: Record<string, PendingModelData>;
  isModelDataLoading: boolean;
  setDatabaseId: (databaseId: string) => void;
  setSelectedModels: (models: ModelSelectItem[]) => void;
  setPendingModelData: (data: Record<string, PendingModelData>) => void;
  setIsModelDataLoading: (loading: boolean) => void;
};

export const ImportModelContext = React.createContext<ImportModelContextValue>({
  databaseId: '',
  dataModels: emptyArray as any,
  unimportableNamedGraphIris: emptyArray as any,
  selectedModels: emptyArray as any,
  pendingModelData: {},
  isModelDataLoading: false,
  setDatabaseId: noop,
  setSelectedModels: noop,
  setPendingModelData: noop,
  setIsModelDataLoading: noop,
});

export const useImportModel = () => {
  return React.useContext(ImportModelContext);
};

export const useImportModelValue = (): ImportModelContextValue => {
  const [databaseId, setDatabaseId] = React.useState<string>('');
  const [selectedModels, setSelectedModels] = React.useState<ModelSelectItem[]>(
    []
  );
  const [pendingModelData, setPendingModelData] = React.useState<
    Record<string, PendingModelData>
  >({});
  const [isModelDataLoading, setIsModelDataLoading] =
    React.useState<boolean>(false);

  const { dataModels, unimportableNamedGraphIris } = useDataModels(
    databaseId,
    selectedModels
  );

  return {
    databaseId,
    dataModels,
    unimportableNamedGraphIris,
    selectedModels,
    pendingModelData,
    isModelDataLoading,
    setDatabaseId,
    setSelectedModels,
    setPendingModelData,
    setIsModelDataLoading,
  };
};
